import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { FaEye, FaSearch } from "react-icons/fa";
import Pagination from "../../../helper/Pagination";
import ScanDetailsOffcanvas from "./ScanDetailsOffcanvas";
import { getOemScansRequest } from "../../redux/actions/scanActions";
import { getOemNames } from "../../redux/actions/oemActions";
import { Badge } from "react-bootstrap";

const OemScan = () => {
  const dispatch = useDispatch();
  const { oemScans, oemPagination, loading, error } = useSelector(
    (state) => state.scan
  );
  const { oemNames } = useSelector((state) => state.oem);
  const [currentPage, setCurrentPage] = useState(1);
  const [oemFilter, setOemFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedScan, setSelectedScan] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    dispatch(getOemNames());
  }, [dispatch]);

  // Reset to page 1 when search term or OEM filter changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, oemFilter]);

  useEffect(() => {
    fetchOemScans();
  }, [currentPage, oemFilter, searchTerm]);

  const fetchOemScans = () => {
    const params = {
      limit: 10,
      page: currentPage,
      search: searchTerm.trim(),
      oemId: oemFilter?.value || "",
    };
    dispatch(getOemScansRequest(params));
  };

  const handleViewDetails = (scan) => {
    setSelectedScan(scan);
    setShowOffcanvas(true);
  };

  return (
    <>
      <div className="page-container">
        <div className="page-card scroll-container">
          <div className="table-section">
            <div className="d-flex justify-content-end gap-3 align-items-center mb-2">
              <Select
                value={oemFilter}
                onChange={setOemFilter}
                options={oemNames?.map((oem) => ({
                  value: oem._id,
                  label: oem.companyName,
                }))}
                placeholder="All OEM"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "200px",
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: "30px",
                    height: "30px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    "&:hover": {
                      border: "1px solid #ddd",
                    },
                  }),
                }}
              />
              <div className="position-relative">
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value.trimStart())}
                  style={{ width: "200px" }}
                />
                {searchTerm === "" && (
                  <div
                    className="position-absolute"
                    style={{
                      top: "50%",
                      right: "13px",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    <FaSearch />
                  </div>
                )}
              </div>
            </div>
            <div className="table-scroll-wrapper">
              <table className="partners-table" key={`${searchTerm}-${oemFilter?.value || 'all'}-${currentPage}`}>
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Domain</th>
                    <th>OEM Partner</th>
                    <th>Verified</th>
                    <th>Language</th>
                    <th>Report Status</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="10"
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#666",
                        }}
                      >
                        <div className="loading-spinner">
                          <div className="spinner"></div>
                          <p>Loading...</p>
                        </div>
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="10" className="text-center text-danger">
                        {error}
                      </td>
                    </tr>
                  ) : !loading && Array.isArray(oemScans) && oemScans.length === 0 ? (
                    <tr>
                      <td
                        colSpan="10"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "#666",
                        }}
                      >
                        No scan data available
                      </td>
                    </tr>
                  ) : !loading && Array.isArray(oemScans) && oemScans.length > 0 ? (
                    oemScans.map((scan, index) => (
                      <tr key={scan._id || index}>
                        <td>{(oemPagination?.offset || (currentPage - 1) * 10) + index + 1}</td>
                        <td>
                          {`${scan.firstName || ""} ${
                            scan.lastName || ""
                          }`.trim() || "-"}
                        </td>
                        <td>{scan.email || "-"}</td>
                        <td>{scan.domain || "-"}</td>
                        <td>{scan.oemPartner?.companyName || "-"}</td>
                        <td>
                          <span
                            className={`badge ${
                              scan.verified ? "bg-success" : "bg-secondary"
                            }`}
                          >
                            {scan.verified ? "Yes" : "No"}
                          </span>
                        </td>
                        <td>
                          {scan.language === "eng"
                            ? "English"
                            : "Japanese" || "-"}
                        </td>
                           <td>
                            <div>
                              <Badge
                                bg={
                                  scan.domainReport.reportSend
                                    ? "success"
                                    : "warning"
                                }
                              >
                                {scan.domainReport.reportSend
                                  ? "Sent"
                                  : "Pending"}
                              </Badge>
                            </div>
                          </td>
                        <td>
                          {scan.domainReport?.createdAt
                            ? new Date(
                                scan.domainReport.createdAt
                              ).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>
                          <div className="row-actions">
                            <div
                              className="edit-row-btn"
                              title="View Details"
                              onClick={() => handleViewDetails(scan)}
                            >
                              <FaEye />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : null}
                </tbody>
              </table>
            </div>
            <Pagination
              currentPage={currentPage}
              totalPages={oemPagination?.totalPages || 1}
              totalItems={oemPagination?.totalItems || 0}
              itemsPerPage={oemPagination?.limit || 10}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>

      <ScanDetailsOffcanvas
        isOpen={showOffcanvas}
        onClose={() => setShowOffcanvas(false)}
        scan={selectedScan}
      />
    </>
  );
};

export default OemScan;
